import { render, staticRenderFns } from "./fileupload.vue?vue&type=template&id=23474052&"
import script from "./fileupload.vue?vue&type=script&lang=js&"
export * from "./fileupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports